import React, { useState } from 'react';
import CampaignEditor from '../create/CampaignEditor';
import CampaignAds from '../create/CampaignAds';
import { CampaignTab } from '../../../constants/common';
import { ICampaignAdDetails } from '../../../interfaces/campaign-ads.interface';

interface IProps {
    store: any;
    activeTab: CampaignTab;
    setActiveTab: React.Dispatch<React.SetStateAction<CampaignTab>>;
    generatingCampaign: boolean;
    selectedCampaignAds: ICampaignAdDetails[];
    setGeneratingCampaign: React.Dispatch<React.SetStateAction<boolean>>;
    setSelectedCampaignAds: React.Dispatch<React.SetStateAction<ICampaignAdDetails[]>>;
    fetchCampaignAdsIntervalRef: React.MutableRefObject<NodeJS.Timeout | null>;
    campaignAdsLoading: boolean;
    setCampaignAdsLoading: React.Dispatch<React.SetStateAction<boolean>>;
}

const CreateTab = ({
    store,
    activeTab,
    setActiveTab,
    generatingCampaign,
    selectedCampaignAds,
    setGeneratingCampaign,
    setSelectedCampaignAds,
    fetchCampaignAdsIntervalRef,
    campaignAdsLoading,
    setCampaignAdsLoading,
}: IProps) => {
    const [isEditorOpen, setIsEditorOpen] = useState(false);

    return (
        <div className="tw-w-full tw-h-full">
            {isEditorOpen ? (
                <CampaignEditor store={store} setIsEditorOpen={setIsEditorOpen} />
            ) : (
                <CampaignAds
                    store={store}
                    activeTab={activeTab}
                    setActiveTab={setActiveTab}
                    generatingCampaign={generatingCampaign}
                    setIsEditorOpen={setIsEditorOpen}
                    selectedCampaignAds={selectedCampaignAds}
                    setGeneratingCampaign={setGeneratingCampaign}
                    setSelectedCampaignAds={setSelectedCampaignAds}
                    fetchCampaignAdsIntervalRef={fetchCampaignAdsIntervalRef}
                    campaignAdsLoading={campaignAdsLoading}
                    setCampaignAdsLoading={setCampaignAdsLoading}
                />
            )}
        </div>
    );
};

export default CreateTab;
